<template>
  <el-checkbox-group class="checkbox-group inline" v-model="checkboxValue">
    <el-checkbox
      class="checkbox inline"
      :class="{ bordered: border }"
      :border="border"
      v-for="(label, val) in labels"
      :key="val"
      :label="val"
    >
      {{ translate ? $t(label) : label }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'CheckboxGroup',
  props: {
    value: {
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    translate: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    keysIsInt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxValue: {
      get() {
        if (!this.keysIsInt) return this.value

        return this.value.map(item => `${item}`)
      },

      set(checkboxValue) {
        let resultValues = checkboxValue

        if (this.keysIsInt) {
          resultValues = resultValues.map(item => parseInt(item))
        }

        this.$emit('input', resultValues)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-group {
  &.inline {
    display: inline-flex;
    width: 100%;
  }
}
.checkbox {
  margin-right: 12px;
  margin-left: 0 !important;
  &:last-child {
    margin-right: 0;
  }
  &.inline {
    flex-shrink: 0;
    flex-grow: 1;
  }
  &.bordered {
    padding-left: 16px;
    padding-top: 13px;
    padding-bottom: 13px;
    height: 48px;
  }
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #1d87c8 !important;
  background-color: #1d87c8;
}
/deep/ .el-checkbox.is-bordered.is-checked {
  border-color: #1d87c8;
  background-color: #e6f3fb;
}
/deep/ .el-checkbox__inner {
  border-color: #dcdfe6 !important;
  background-color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
/deep/ .el-checkbox__inner::after {
  height: 8px;
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  top: 3px;
  left: 6px;
  width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/CheckboxGroup.vue